import { Badge } from "../ui/Badge";

/** Marks a record created by the content pipeline rather than uploaded by hand. */
export function IngestedBadge() {
  return <Badge variant="info">Ingested</Badge>;
}
